module.exports = __webpack_public_path__ + "static/media/magnifier-searchBar.01af1826.svg";